import React from 'react'
import { MyDataTable, MyColumn, MyChip } from '@interstellar-component'

// MyChip has no "brand" color — "primary" maps to the brand/navy tokens. We
// color each number deterministically so the same number reads as the same
// color across every row (the multi-tone soft-filled pills from Figma).
const NUMBER_CHIP_COLORS = ['primary', 'blue', 'indigo']
function numberChipColor(num) {
  const digits = String(num).replace(/\D/g, '')
  let sum = 0
  for (let i = 0; i < digits.length; i += 1) sum += Number(digits[i]) || 0
  return NUMBER_CHIP_COLORS[sum % NUMBER_CHIP_COLORS.length]
}

export default function DiscoveredContactTable({ data, searchTerm }) {
  // Simple filter for the demo
  const filteredData = data.filter((item) =>
    item.label.toLowerCase().includes(searchTerm.toLowerCase())
  )

  return (
    <MyDataTable values={{ data: filteredData }} className="border-none shadow-none">
      <MyColumn
        header="Labels"
        field="label"
        body={(row) => <span className="text-sm-semibold text-gray-900 block py-1">{row.label}</span>}
      />
      <MyColumn
        header="Count"
        field="count"
        body={(row) => <span className="text-sm-regular text-gray-600 block py-1">{row.count}</span>}
      />
      <MyColumn
        header="Associated Number"
        field="numbers"
        body={(row) => (
          <div className="flex items-center gap-2 py-1 flex-wrap">
            {row.numbers.map((num, idx) => (
              <MyChip
                key={idx}
                label={num}
                color={numberChipColor(num)}
                variant="filled"
                size="sm"
                rounded="full"
              />
            ))}
            {row.extra ? (
              <MyChip
                label={`+${row.extra}`}
                color="gray"
                variant="filled"
                size="sm"
                rounded="full"
              />
            ) : null}
          </div>
        )}
      />
    </MyDataTable>
  )
}
